import { render, staticRenderFns } from "./LayoutHorizontal.vue?vue&type=template&id=98bc556c&"
import script from "./LayoutHorizontal.vue?vue&type=script&lang=js&"
export * from "./LayoutHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98bc556c')) {
      api.createRecord('98bc556c', component.options)
    } else {
      api.reload('98bc556c', component.options)
    }
    module.hot.accept("./LayoutHorizontal.vue?vue&type=template&id=98bc556c&", function () {
      api.rerender('98bc556c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/horizontal/LayoutHorizontal.vue"
export default component.exports